import { render } from "./DesktopNav.vue?vue&type=template&id=319f823f&scoped=true&ts=true"
import script from "./DesktopNav.vue?vue&type=script&lang=ts"
export * from "./DesktopNav.vue?vue&type=script&lang=ts"

import "./DesktopNav.vue?vue&type=style&index=0&id=319f823f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319f823f"]])

export default __exports__